import isFunction from 'lodash/isFunction';

export function runIfFn<ValueOrFnReturnType, FnArgs>(
  valueOrFn: ValueOrFnReturnType | ((...fnArgs: FnArgs[]) => ValueOrFnReturnType),
  ...args: FnArgs[]
): ValueOrFnReturnType {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
